var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicenceStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50648 7H34.1574C36.095 7 37.6667 8.54428 37.6667 10.4488V28.5512C37.6667 30.4569 36.095 32 34.1574 32H6.50648C4.57016 32 3 30.457 3 28.5512V10.4488C3 8.5446 4.57016 7 6.50648 7ZM21.9336 25.3248H28.9171V23.0273H21.9336V25.3248ZM21.9335 20.2415H33.2937V17.944H21.9335V20.2415ZM21.9335 15.1582H33.2937V12.8607H21.9335V15.1582ZM15.542 12.926C15.0116 12.4064 14.2918 12.1143 13.5418 12.1143L13.5417 12.1144C12.7924 12.1185 12.0754 12.412 11.5457 12.9302C11.0168 13.4491 10.7172 14.1516 10.713 14.8856C10.713 15.6205 11.0111 16.3257 11.5415 16.8453C12.072 17.3649 12.7917 17.657 13.5418 17.657C14.2918 17.657 15.0116 17.3649 15.542 16.8453C16.0724 16.3256 16.3706 15.6205 16.3706 14.8856C16.3706 14.1508 16.0725 13.4456 15.542 12.926ZM10.847 19.7258C9.15909 20.4495 7.85691 21.8318 7.25566 23.5385C7.17006 23.7653 7.23251 24.0203 7.41281 24.1852C9.04666 25.7262 11.2265 26.5867 13.4947 26.5867C15.7629 26.5867 17.9427 25.7262 19.5766 24.1852C19.7569 24.0203 19.8187 23.7653 19.7338 23.5385C19.1319 21.8318 17.8304 20.4496 16.1424 19.7258C14.4545 19.0014 12.5343 19.0014 10.847 19.7258Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenceStatus);
export default __webpack_public_path__ + "static/media/LicenceStatus.70a80a22cf34f223515ad25547666b7d.svg";
export { ForwardRef as ReactComponent };